import { useEffect } from "react";
import { isMobileOnly, isTablet } from "react-device-detect";
import { Outlet } from "react-router-dom";
import imgMobile from "src/assets/images/hotel-layout/bg-header-mobile.svg";
import imgTablet from "src/assets/images/hotel-layout/bg-header-tablet.svg";
import img from "src/assets/images/hotel-layout/bg-header.svg";
import FooterComponent from "src/components/footer";
import HeaderReservationComponent from "src/components/header-reservation";
import "./index.scss";

interface IProps {
  isHeader?: boolean;
  noBlur?: boolean;
}

function BaseHotelLayoutComponent({
  isHeader = false,
  noBlur = false,
}: IProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {isHeader && <HeaderReservationComponent />}
      <div
        className={
          isMobileOnly
            ? "BaseHotelLayoutStyleMobile"
            : isTablet
            ? "BaseHotelLayoutStyleTablet"
            : "BaseHotelLayoutStyle"
        }
      >
        <div
          className="position-relative"
          style={{
            height: isMobileOnly ? 371 : isTablet ? 350 : 419,
            overflow: "hidden",
          }}
        >
          <img
            src={isMobileOnly ? imgMobile : isTablet ? imgTablet : img}
            alt=""
            style={{
              width: window.screen.width,
              height: isMobileOnly ? 443 : isTablet ? 235 : 419,
              objectFit: "none",
            }}
          />
          {Boolean(!noBlur) && <div className="nafutel-blur"></div>}
        </div>
        <div className="WrapLayout">
          <Outlet />
        </div>
      </div>
      {isHeader && <FooterComponent isResale={false} />}
    </>
  );
}

export default BaseHotelLayoutComponent;
